<template>
    <modal
        :value="value"
        content-class="ssid-list"
        :has-padding="false"
        @input="(val) => $emit('input', val)"
    >
        <div class="ssid-list-body">
            <h1 class="text-center">
                {{ $t("message.ssid.message.registerSSIDTitle") }}
            </h1>

            <app-button
                class="ssid-create-activator btn-primary_bottom"
                :label="$t('message.ssid.message.registerSSID')"
                icon="plus-circle-outline"
                flat
                underline
                primary
                @click="isCreateModalOpen = true"
            />

            <local-ssid-create-form
                v-if="isCreateModalOpen"
                v-model="isCreateModalOpen"
                @submit="load"
            />

            <v-data-table
                class="ssid-list-body-table card-data-table"
                :headers="headers"
                :items="list"
                :loading="loading"
                :hide-actions="true"
                :no-data-text="$t('message.generics.message.noResultsFound')"
            >
                <template slot="items" slot-scope="props">
                    <local-ssid-list-item
                        :item="props.item"
                        @edited="load"
                        @deleted="load"
                        :key="props.item.name"
                    />
                </template>
            </v-data-table>
        </div>
    </modal>
</template>

<script>
import AccessPointControllerForm from "@components/modules/access-point/controller/form/AccessPointControllerForm";
import AccessPointControllerListItem from "@components/modules/access-point/controller/list/item/AccessPointControllerListItem";
import Modal from "@/components/generic/Modal";
import LocalSsidCreateForm from "@components/modules/local/ssid/modal/LocalSSIDCreateForm.vue";
import LocalSsidListItem from "@components/modules/local/ssid/LocalSSIDListItem.vue";
import AppButton from "@/components/generic/button/Button";

export default {
    components: {
        AccessPointControllerForm,
        AccessPointControllerListItem,
        LocalSsidCreateForm,
        LocalSsidListItem,
        Modal,
        AppButton,
    },

    data() {
        return {
            loading: false,
            list: [],
            isCreateModalOpen: false,
        };
    },

    mounted() {
        this.load();
    },

    props: {
        value: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t("message.generics.message.name"),
                    value: "name",
                    sortable: false,
                },
                {
                    text: this.$t("message.admGenerics.message.edition"),
                    value: "",
                    sortable: false,
                    width: 100,
                },
            ];
        },
    },

    methods: {
        async load() {
            this.loading = true;

            const list = await this.$api.core.ssid.getAll();

            this.list = list;

            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.ssid-list {
    .ssid-list-body {
        padding: 30px 20px 50px;
    }
}

.ssid-create-activator {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-left: 25px;

    .ssid-create-activator-icon {
        display: flex;
        align-items: center;
        margin-right: 5px;
    }
}

.ssid-list-body-table {
    max-height: 375px;
    overflow-y: auto;
}
</style>
